<h1 mat-dialog-title>Payment Authorization</h1>
<div mat-dialog-content style="min-height: 275px;">

  <div *ngIf="!isDoItYourself else doItYourself">
    <form [formGroup]="formPayeeInfo" autocomplete="nope">
      <p>Who do you authorize for payment?</p>
      <mat-radio-group
        id="payeeTypeCode"
        name="payeeTypeCode"
        formControlName="payeeTypeCode"
        (change)="onChangeEventPayee($event)"
        class="retrofit-task-radio-group">
        <div>
          <!--<mat-radio-button value=700000000 [checked]='payeeIsHomeowner'>-->
          <mat-radio-button value=700000000>
            Homeowner
          </mat-radio-button>
        </div>
        <div>
          <!--<mat-radio-button value=700000001 [checked]='payeeIsContractor'>-->
          <mat-radio-button value=700000001>
            Contractor
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </form>
  </div>
  <ng-template #doItYourself>
    <h6>Do it myself retrofit</h6>
    <p>You can authorize payment only for yourself</p>
  </ng-template>

  <div style="margin-top: 15px;"
    *ngIf="currentPayee else payeeInstructions">
    <p *ngIf="data.pafCompany && data.pafCompany.length > 0"
      style="margin-bottom: 3px;">
      {{data.pafCompany}}
    </p>
    <p>
      {{data.pafFullName}}
    </p>
    <address>{{data.pafAddressStreet}}<br>
    {{data.pafAddressCity}}, {{data.pafAddressState}}<br>
    {{data.pafAddressZip}}
    </address>
    <small>Authorized on {{currentDate.toLocaleDateString("en-US")}}</small>
  </div>
  <ng-template #payeeInstructions>
    <div style="margin-top: 21px;">
      <p>
        Payment authorization is used to authorize to whom the Earthquake Brace + Bolt incentive payment is to be paid.
      </p>
      <p>
        For more information visit www.earthquakebracebolt.com.
      </p>
    </div>
  </ng-template>

</div>
<div mat-dialog-actions style="margin-top: 18px !important; float: right !important;">
  <button mat-button id="dialogPaFormCancelButton"
    style="margin-right: 6px;"
    (click)="onClickCancel()">
    CANCEL
  </button>
  <button mat-flat-button id="dialogPaFormSaveButton"
    (click)="onClickSave()"
    color="primary"
    [disabled]="(formPayeeInfo.pristine || formPayeeInfo.invalid) && !this.isDoItYourself">
    SAVE
  </button>
</div>